$(function () {
    // TVC
    var $tvc = $('#tvc');
    if ($tvc.length) {
        function loadTvcIframe() {
            var $iframe = $('#tvc_video_max');
            if (!$iframe.length) return;
            var lazySrc = $iframe.attr('data-lazysrc');
            if (lazySrc && !$iframe.attr('src')) {
                $iframe.attr('src', lazySrc);
            }
        }

        if ($(window).width() > 1080) {
            $tvc.find('.tvc_youtube_video .youtube_video_content .close_btn').click(function () {
                $tvc.find('.tvc_youtube_video').hide();
            });
            $tvc.find('.tvc_playBox').click(function () {
                loadTvcIframe();
                $tvc.find('.tvc_youtube_video').show();
            });
        } else {
            $tvc.find('.tvc_youtube_video .youtube_video_content .close_btn').click(function () {
                $tvc.find('.tvc_youtube_video').animate({ top: '100vh', opacity: 0 }, 300);
            });
            $tvc.find('.tvc_playBox').click(function () {
                loadTvcIframe();
                $tvc.find('.tvc_youtube_video').animate({ top: '0', opacity: 1 }, 300);
            });
        }
    }


    // 初始化swiper
    var swiper = new Swiper('#module19-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 30,
        speed: 600,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });



    // module11：固定一屏，遮罩 → 内容+认证标识同时出现
    gsap.registerPlugin(ScrollTrigger);

    var module11 = document.querySelector('#ArtPlayPad .module11 .display-feature');
    if (module11) {
        var mask = module11.querySelector('.display-feature__bg-mask');
        var content = module11.querySelector('.display-feature__content');
        var note = module11.querySelector('.display-feature__note');

        gsap.set(content, { xPercent: -50, yPercent: -50, autoAlpha: 0, y: 24 });
        gsap.set(note, { autoAlpha: 0, y: 20 });
        gsap.set(mask, { opacity: 0 });

        var phase = 0;

        function getPhase(p) {
            return p >= 0.5 ? 2 : 1;
        }

        function hideOverlay() {
            gsap.killTweensOf([content, note]);
            gsap.set(content, { xPercent: -50, yPercent: -50, autoAlpha: 0, y: 24 });
            gsap.set(note, { autoAlpha: 0, y: 20 });
        }

        function showOverlay(animated) {
            gsap.killTweensOf([content, note]);
            gsap.set(content, { xPercent: -50, yPercent: -50 });
            if (animated) {
                gsap.to(content, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power2.out' });
                gsap.to(note, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power2.out' });
            } else {
                gsap.set(content, { autoAlpha: 1, y: 0 });
                gsap.set(note, { autoAlpha: 1, y: 0 });
            }
        }

        function resetModule11() {
            phase = 0;
            gsap.killTweensOf([mask, content, note]);
            gsap.set(mask, { opacity: 0 });
            hideOverlay();
        }

        function playMask() {
            gsap.fromTo(mask,
                { opacity: 0 },
                { opacity: 1, duration: 0.8, ease: 'power2.inOut' }
            );
        }

        function applyPhase(next, animated) {
            if (next === phase) return;
            var prev = phase;
            phase = next;

            gsap.set(mask, { opacity: 1 });

            if (next === 1) {
                hideOverlay();
            } else if (next === 2) {
                showOverlay(animated && prev < 2);
            }
        }

        function getPinStart() {
            return window.innerWidth <= 1024 ? 'top 45px' : 'top 50px';
        }

        ScrollTrigger.create({
            trigger: module11,
            pin: true,
            start: getPinStart,
            end: '+=150%',
            onEnter: function () {
                resetModule11();
                playMask();
                phase = 1;
            },
            onEnterBack: function (self) {
                gsap.killTweensOf(mask);
                phase = -1;
                applyPhase(getPhase(self.progress), false);
            },
            onUpdate: function (self) {
                applyPhase(getPhase(self.progress), true);
            },
            onLeaveBack: resetModule11,
        });
    }
})